import { createElement, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import useAuthStore from "./data/stores/authStore";

const GeneratePage = (pageName: string, folder: string) => {
	const component = () => require(`./${folder}/${pageName}`).default;
	let navigate = useNavigate();

	try {
		return createElement(component());
	} catch (e) {
		console.log(e);
		navigate("/");
	}
};

const PageRender = () => {
	const { page, id, step } = useParams();
	const { isAuth } = useAuthStore();
	const escape2 = [
			"add-tool",
			"add-user",
			"add-data",
			"application-level",
			"add-request",
		],
		location = useLocation(),
		navigate = useNavigate();

	useEffect(() => {
		if (
			isAuth &&
			(location.pathname === "/login" ||
				location.pathname.startsWith("/login/"))
		) {
			navigate("/");
		}
	}, [navigate, isAuth, location]);

	let pageName = "";
	if (step) {
		pageName = `${page}/${id}/${"[id]"}`;
	} else if (id) {
		if (
			["tools", "users", "data", "new-request"]?.includes(page) &&
			escape2.includes(id)
		) {
			pageName = `${page}/${id}`;
		} else {
			pageName = `${page}/${"[id]"}`;
		}
	} else {
		pageName = `${page}`;
	}

	return GeneratePage(pageName, isAuth ? "pages" : "screens");
};

export default PageRender;
